<avi-confirmation
    class="clr-wrapper"
    (onClose)="handleClose()"
    [headerText]="l10nKeys.modalTitle | vtranslate"
>
    <ng-container ngProjectAs="avi-confirmation_modal-content">
        <avi-alert-group
            *ngIf="error"
            alertType="danger"
        >
            <span>{{ error }}</span>
        </avi-alert-group>
        <div class="license-add-panel-modal__content">
            <div class="full-modal-config__section">
                <div class="full-modal-config__form-control">
                    <avi-input-container noMarginTop>
                        <label
                            aviLabelWithTooltip
                            objectType="SingleLicense"
                            fieldName="serial_key"
                            for="serial_key"
                            required
                        >
                            {{ l10nKeys.licenseKeyLabel | vtranslate }}
                        </label>
                        <input
                            class="sel-license-key"
                            clrInput
                            name="serial_key"
                            id="serial_key"
                            placeholder="{{ l10nKeys.licenseKeyPlaceholder | vtranslate }}"
                            [(ngModel)]="newLicenseKey"
                            regexPattern="licenseSerialKey"
                        />
                    </avi-input-container>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container ngProjectAs="avi-confirmation_modal-actions">
        <cds-button
            action="outline"
            (click)="handleClose()"
            (keydown.enter)="handleClose()"
        >
            {{ l10nKeys.cancelButtonLabel | vtranslate }}
        </cds-button>
        <cds-button
            class="sel-apply-key"
            (click)="applyNewLicenseKey()"
            (keydown.enter)="applyNewLicenseKey()"
            [loadingState]="loadingState"
            [disabled]="!newLicenseKey"
        >
            {{ l10nKeys.modalTitle | vtranslate }}
        </cds-button>
    </ng-container>
</avi-confirmation>
